import React, { PureComponent } from 'react';
import { launchFullscreen } from '../../utils/fullScreenAPI';
import { swip, tap } from '../../utils/swip';
import { calTime } from '../../utils/util';
import { Stat } from '../../utils/vStat';
import { VideoContext } from '../context/videoContext';
import Core from './core';
import Poster from './poster/';
import PlayBtn from './playBtn/';
import Title from './title/';
import ShortTips from './shortTips/';
import TipsMask from './tipsMask/';
import ControllBar from './controlBar/';
/* eslint-enable init-declarations */
/**
 * 移动端视频播放器
 */
class MobileVideo extends PureComponent {
    constructor(props) {
        super(props);
        this.handleVideoAreaClick = (currentBtnStatus, e) => {
            console.log('handleVideoAreaClick 函数执行');
            if (this.state.openClient === 1) {
                return;
            }
            if (e) {
                const clickDomId = (e.target && e.target.id) || '';
                console.log('clickDomId', clickDomId);
                // 如果点击的是控制条区域，则不做操作
                if (clickDomId === 'controllBar') {
                    console.log('点击的是控制条区域');
                    return;
                }
                // 如果点击区域是播放按钮，不做处理，交由 this.handlePlayBtnClick 处理
                if (clickDomId === 'playBtn') {
                    // console.log('点击的是播放区域，交由 this.handlePlayBtnClick处理');
                    // this.handlePlayBtnClick(currentBtnStatus);
                    return;
                }
                // 如果点击的是视频播放的空白区域，则不做任何处理
                if (clickDomId === 'player') {
                    return;
                }
            }
            const { dispatch } = this.props;
            if (currentBtnStatus === 'play' && this.core && this.core.current) {
                console.log('-----------play----------');
                this.core.current.play();
            }
            else if (currentBtnStatus === 'pause') {
                console.log('-----------pause----------');
                this.core && this.core.current && this.core.current.pause();
            }
            else if (currentBtnStatus === 'ended' && this.core && this.core.current) {
                dispatch({ type: 'updateCurrent', currentTime: 0 });
                this.core.current.play();
            }
            let newPlayBtnStatus = currentBtnStatus === 'play' ? 'pause' : 'play';
            if (currentBtnStatus === 'ended') {
                newPlayBtnStatus = 'pause';
            }
            return currentBtnStatus !== 'pause'
                ? dispatch({
                    type: 'changePlayBtnStatus',
                    playBtnStatus: newPlayBtnStatus,
                })
                : false;
        };
        this.handlePlayBtnClick = (currentBtnStatus) => {
            const { dispatch, playermsg } = this.props;
            // 断流处理
            if (playermsg.cutOffPlay &&
                playermsg.eachTimeClickPlayer &&
                typeof playermsg.eachTimeClickPlayer === 'function') {
                // 在 this.handleClick 函数中仅调用一次，保证断流点击播放按钮时不会播放
                return;
            }
            // 开始播放前如果有自定义函数可以进行调用
            if (playermsg.beforePlayCB && typeof playermsg.beforePlayCB === 'function' && !this.hasVideoStartPlay) {
                const cb = this.exposeApis();
                this.hasVideoStartPlay = true;
                playermsg.beforePlayCB(cb);
                return;
            }
            if (currentBtnStatus === 'play' && this.core && this.core.current) {
                this.core.current.play();
            }
            else if (currentBtnStatus === 'pause' && this.core && this.core.current) {
                // 如果有截流功能，则在拖动进度条之后，超过截流进度时，让视频暂停
                if (this.state.openClient === 1 && !this.core.current.isPaused()) {
                    this.core.current.pause();
                }
                else if (!this.core.current.isPaused()) {
                    this.core.current.pause();
                }
            }
            else if (currentBtnStatus === 'ended' && this.core && this.core.current) {
                dispatch({ type: 'updateCurrent', currentTime: 0 });
                this.core.current.play();
            }
            let newPlayBtnStatus = currentBtnStatus === 'play' ? 'pause' : 'play';
            if (currentBtnStatus === 'ended') {
                newPlayBtnStatus = 'pause';
            }
            return dispatch({
                type: 'changePlayBtnStatus',
                playBtnStatus: newPlayBtnStatus,
            });
        };
        this.handleFullScreenBtnClick = (e) => {
            // this.props.dispatch({
            //     type: 'changePlayBtnStatus',
            //     playBtnStatus: 'play',
            // });
            e.stopPropagation();
            if (this.core && this.core.current && this.core.current.el && this.core.current.el.current) {
                if (this.props.playermsg.fullscreenListener) {
                    this.props.playermsg.fullscreenListener(true);
                }
                launchFullscreen(this.core.current.el.current, () => {
                    document.querySelectorAll('#videoContainer')[0].classList.toggle('fullScreen');
                });
            }
        };
        this.videoErrorHandle = () => {
            this.props.dispatch({
                type: 'changePlayBtnStatus',
                playBtnStatus: 'play',
            });
            // 重新尝试播放
            if (this.core && this.core.current && this.core.current.el && this.core.current.el.current) {
                this.core.current.el.current
                    .play()
                    .then(() => {
                    this.props.dispatch({
                        type: 'changePlayBtnStatus',
                        playBtnStatus: 'pause',
                    });
                })
                    .catch((e) => {
                    console.error(e);
                    if (this.core && this.core.current) {
                        this.core.current.pause();
                    }
                    this.props.dispatch({
                        type: 'changePlayBtnStatus',
                        playBtnStatus: 'play',
                    });
                });
            }
        };
        this.unHandleTimeUpdateEvent = () => {
            if (!(this.core && this.core.current && this.core.current.isPaused())) {
                this.props.dispatch({ type: 'videoTimeUpdate' });
            }
            const { playermsg: { firstFrameStatisticsCB = null }, } = this.props;
            // 首帧播放自定义统计上报 start
            if (firstFrameStatisticsCB &&
                typeof firstFrameStatisticsCB === 'function' &&
                this.sendFirstFrameCustomStatistics) {
                firstFrameStatisticsCB();
                this.sendFirstFrameCustomStatistics = false;
            }
            // 首帧播放自定义统计上报 end
            if (this.core) {
                const currentTime = this.core && this.core.current && this.core.current.getCurrentTime();
                const bufferedTime = this.core && this.core.current && this.core.current.getBuffereds();
                const duration = this.core && this.core.current && this.core.current.getBuffereds();
                // 视频播放 到了截流规定的时间
                if (this.state.openTipsShow !== 0 && currentTime && currentTime >= this.state.mobileClosureTime) {
                    console.log('316');
                    // 试看结束，需跳转到客户端连接观看
                    this.handlePlayBtnClick('pause');
                    this.setState({
                        openClient: this.props.videoConfig.guideAppSetting && this.props.videoConfig.guideAppSetting.enable
                            ? this.props.videoConfig.guideAppSetting.enable
                            : 0,
                    });
                }
                if (this.end && bufferedTime === duration && duration !== 0) {
                    this.vStat.sendVplayer(307000);
                    this.end = false;
                }
                this.props.dispatch({ type: 'updateCurrent', currentTime });
            }
        };
        this.unHandleVideoEndedEvent = () => {
            this.props.dispatch({ type: 'changePlayBtnStatus', playBtnStatus: 'ended' });
            if (this.props.playermsg && this.props.playermsg.videoPlayerEndCb) {
                this.props.playermsg.videoPlayerEndCb();
            }
        };
        this.unHandleLoadStartEvent = () => {
            if (this.loadstartfirst) {
                this.vStat.sendVplayer(208000);
                this.loadstartfirst = false;
            }
            // 10s超时报警
            let time = 0;
            this.tenSecTimeOutError = window.setInterval(() => {
                time++;
                if (time >= 10) {
                    console.error('10s timeout for loading video');
                    if (this.tenSecTimeOutError) {
                        clearInterval(this.tenSecTimeOutError);
                    }
                }
            }, 1000);
        };
        this.unHandleLoadedDataEvent = () => {
            // 获取到视频数据时取消十秒超时警报
            if (this.tenSecTimeOutError) {
                clearInterval(this.tenSecTimeOutError);
            }
            /**
             * 发送首字节响应统计
             */
            if (this.loadeddatafirst) {
                this.vStat.sendVplayer(302000);
                this.loadeddatafirst = false;
            }
        };
        this.exposeApis = () => {
            const apis = {};
            apis.play = () => {
                this.handlePlayBtnClick('play');
            };
            apis.pause = () => {
                // console.log('执行pause')
                this.handlePlayBtnClick('pause');
            };
            apis.getCurrentTime = () => {
                return this.core && this.core.current && this.core.current.getCurrentTime();
            };
            apis.getDuration = () => {
                return this.core && this.core.current && this.core.current.getDuration();
            };
            return apis;
        };
        this.unHandleVideoCanPlayEvent = () => {
            if (this.first_play) {
                // 发送首画面呈现统计
                this.vStat.sendVplayer(303000);
                // 发送cv统计
                this.vStat.sendMedia('cv');
                this.first_play = false;
            }
            if (this.core && this.core.current) {
                const videoDuration = this.core.current.getDuration();
                const { dispatch } = this.props;
                if (videoDuration) {
                    dispatch({
                        type: 'updateVideoDuration',
                        videoDuration: Math.round(videoDuration),
                    });
                }
            }
        };
        this.unHandleVideoPauseEvent = () => {
            this.props.dispatch({
                type: 'changePlayBtnStatus',
                playBtnStatus: 'play',
            });
            this.vStat.sendVplayer(402000);
        };
        this.unHandleVideoPlayEvent = () => {
            this.vStat.sendVplayer(401000);
            // 播放前执行自定义统计事件
            // 首帧播放自定义统计上报
            const { playermsg: { clickVideoStatisticsCB = null }, } = this.props;
            if (clickVideoStatisticsCB && typeof clickVideoStatisticsCB === 'function') {
                clickVideoStatisticsCB();
            }
        };
        this.unHandleVideoErrorEvent = () => {
            try {
                const errorObj = (this.core &&
                    this.core.current &&
                    this.core.current.el &&
                    this.core.current.el.current &&
                    this.core.current.el.current.error) || { code: 0, message: '' };
                this.coreErrorCode = errorObj.code;
                this.coreErrorCurrent =
                    this.core &&
                        this.core.current &&
                        this.core.current.el &&
                        this.core.current.el.current &&
                        this.core.current.el.current.currentTime;
                if (window && window.BJ_REPORT) {
                    const playerError = {
                        url: (this.core &&
                            this.core.current &&
                            this.core.current.el &&
                            this.core.current.el.current &&
                            this.core.current.el.current.src) ||
                            '',
                        code: errorObj.code,
                        message: errorObj.message,
                        errorProp: {
                            MEDIA_ERR_ABORTED: 1,
                            MEDIA_ERR_DECODE: 3,
                            MEDIA_ERR_NETWORK: 2,
                            MEDIA_ERR_SRC_NOT_SUPPORTED: 4,
                        },
                    };
                    window.BJ_REPORT.report(new Error(JSON.stringify(playerError)), false, 26);
                }
                if (!this.errHasSend) {
                    this.vStat.sendVplayer(`44000${this.coreErrorCode}`);
                    if (!this.coreErrorCurrent) {
                        this.vStat.sendVplayer('301040');
                    }
                    this.errHasSend = true;
                }
            }
            catch (e) {
                console.error(e);
            }
        };
        this.initCoreEventList = () => {
            if (this.core && this.core.current) {
                this.core.current.on('timeupdate', this.unHandleTimeUpdateEvent);
                this.core.current.on('ended', this.unHandleVideoEndedEvent);
                this.core.current.on('loadstart', this.unHandleLoadStartEvent);
                this.core.current.on('loadeddata', this.unHandleLoadedDataEvent);
                this.core.current.on('canplay', this.unHandleVideoCanPlayEvent);
                this.core.current.on('pause', this.unHandleVideoPauseEvent);
                this.core.current.on('play', this.unHandleVideoPlayEvent);
                this.core.current.on('error', this.unHandleVideoErrorEvent);
            }
        };
        this.unBindCoreEvents = () => {
            if (this.core && this.core.current) {
                this.core.current.off('timeupdate', this.unHandleTimeUpdateEvent);
                this.core.current.off('ended', this.unHandleVideoEndedEvent);
                this.core.current.off('loadstart', this.unHandleLoadStartEvent);
                this.core.current.off('loadeddata', this.unHandleLoadedDataEvent);
                this.core.current.off('canplay', this.unHandleVideoCanPlayEvent);
                this.core.current.off('pause', this.unHandleVideoPauseEvent);
                this.core.current.off('play', this.unHandleVideoPlayEvent);
                this.core.current.off('error', this.unHandleVideoErrorEvent);
            }
        };
        this.getRenderArr = (context) => {
            const { videoConfig, postShow, videoConfig: { bigPosterUrl, title, duration, videoType }, playBtnStatus, playBtnShow, titleShow, dispatch, currentTime, controllShow, playermsg: { showPoster, showTitle, showController, showFullScreenBtn, singlePlay }, shortTipsShow, } = context;
            // 截流引流客户端 遮罩界面开启后，去掉 playBtn
            const renderArr = [
                React.createElement(Core, { key: "core", videoConfig: videoConfig, handleVideoClick: () => {
                        dispatch({
                            type: 'clickVideoDom',
                        });
                    }, errorHandle: this.videoErrorHandle, ref: this.core, openClient: this.state.openClient ? this.state.openClient : 0, singlePlay: singlePlay }),
                React.createElement(PlayBtn, { key: "playBtn", playBtnStatus: playBtnStatus, playBtnShow: playBtnShow, handleClickBtn: (e) => {
                        if (e && this.props.playermsg.isCircle && playBtnStatus === 'ended') {
                            e.stopPropagation();
                        }
                        this.handlePlayBtnClick(playBtnStatus);
                    }, openClient: this.state.openClient ? this.state.openClient : 0 }),
            ];
            if (showPoster) {
                renderArr.push(React.createElement(Poster, { key: "poster", postShow: postShow, posterUrl: bigPosterUrl, videoType: videoType }));
            }
            if (showTitle && title) {
                renderArr.push(React.createElement(Title, { key: "title", title: title, titleShow: titleShow }));
            }
            if (currentTime >= this.state.mobileClosureTime - 1) {
                // 快到截留时间之后，不渲染提示条
            }
            else if (shortTipsShow && this.state.openTipsShow === 1) {
                renderArr.push(React.createElement(ShortTips, { key: "shortTips", mobileClosureTime: this.state.mobileClosureTime, callAppConfig: videoConfig.callAppConfig }));
            }
            if (showController) {
                renderArr.push(React.createElement(ControllBar, { key: "controllBar", ref: this.controllBar, current: currentTime, total: duration || 0, controllShow: controllShow, showFullScreenBtn: showFullScreenBtn, handleFullScreen: this.handleFullScreenBtnClick }));
            }
            return renderArr;
        };
        this.handleClick = (playermsg, playBtnStatus, shortTipsShow, e) => {
            // 开始播放前如果有自定义函数可以进行调用
            // 断流处理
            if (playermsg.cutOffPlay &&
                playermsg.eachTimeClickPlayer &&
                typeof playermsg.eachTimeClickPlayer === 'function') {
                // 每次点击仅触发一次
                playermsg.eachTimeClickPlayer();
                return;
            }
            if (playermsg.beforePlayCB && typeof playermsg.beforePlayCB === 'function' && !this.hasVideoStartPlay) {
                const cb = this.exposeApis();
                this.hasVideoStartPlay = true;
                playermsg.beforePlayCB(cb);
            }
            else {
                this.handleVideoAreaClick(playBtnStatus, e);
            }
            if (playermsg.playNotice && typeof playermsg.playNotice === 'function') {
                playermsg.playNotice(playBtnStatus);
            }
        };
        this.controllBar = React.createRef();
        // 播放器核心
        this.core = React.createRef();
        // 第一次下载结束
        this.end = true;
        /**
         * 是否为第一次loadstart
         *
         * @member {Boolean}
         */
        this.loadstartfirst = true;
        /**
         * 是否为第一次loadeddatafirst
         *
         * @member {Boolean}
         */
        this.loadeddatafirst = true;
        /**
         * 是否为第一次播放
         *
         * @member {Boolean}
         */
        this.first_play = true;
        /**
         * 用户寻址次数
         */
        this.seekTime = 0;
        /**
         * 播放首帧自定义统计上报
         */
        this.sendFirstFrameCustomStatistics = true;
        /**
         * 视频是否开始播放
         */
        this.hasVideoStartPlay = false;
        /**
         * 是否已经触发过一次自定义时机事件处理函数
         */
        this.hasHalfWayTriggerEvent = false;
        // 统计
        this.vStat = new Stat(props.videoConfig);
        this.initStat();
        this.state = {
            content: this.props.videoConfig.guideAppSetting && this.props.videoConfig.guideAppSetting.text
                ? this.props.videoConfig.guideAppSetting.text
                : '去凤凰新闻客户端观看完整版',
            openClient: 0,
            mobileClosureTime: this.props.videoConfig.guideAppSetting && this.props.videoConfig.guideAppSetting.duration
                ? this.props.videoConfig.guideAppSetting.duration
                : 0,
            openTipsShow: this.props.videoConfig.guideAppSetting && this.props.videoConfig.guideAppSetting.enable
                ? this.props.videoConfig.guideAppSetting.enable
                : 0,
        };
    }
    initStat() {
        /**
         * 发送vv统计
         */
        this.vStat.sendMedia('vv');
        /**
         * 采样标识统计
         */
        this.vStat.sendVplayer('100000');
    }
    componentDidMount() {
        var _a, _b;
        const { dispatch, videoConfig: { duration = 0 }, } = this.props;
        this.initCoreEventList();
        // 退出全屏
        document.addEventListener('fullscreenchange', (e) => {
            var _a, _b;
            const videoContainerClassList = document.querySelectorAll('#videoContainer')[0].classList;
            const isFull = document.fullscreenElement ||
                document.msFullscreenElement ||
                document.mozFullScreenElement ||
                document.webkitFullscreenElement ||
                false;
            if (!isFull) {
                if (videoContainerClassList) {
                    videoContainerClassList.toggle('fullScreen');
                }
                // if (this.core && this.core.current) {
                //     this.handlePlayBtnClick('pause');
                // }
                if (this.props.playermsg.fullscreenListener && ((_b = (_a = this.core) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.el.current) === e.target) {
                    this.props.playermsg.fullscreenListener(false);
                }
            }
        });
        // 拖动进度条进度点
        if (this.controllBar && this.controllBar.current) {
            const TOUCH_MOVE = typeof window === 'object' && 'ontouchmove' in window ? 'touchmove' : 'mousemove';
            if (TOUCH_MOVE === 'touchmove') {
                swip(this.controllBar.current.timeBar.current, () => {
                    // touch start
                    if (this.core && this.core.current && !this.core.current.isPaused()) {
                        this.core.current.pause();
                    }
                    // console.log('touch start')
                    this.touchStartTime =
                        (this.core && this.core.current && this.core.current.getCurrentTime()) || 0;
                }, (begin, current) => {
                    // touch move
                    // console.log('touch move')
                    setTimeout(() => {
                        this.swipCurrentTime = calTime(this.touchStartTime, begin, current, (this.controllBar &&
                            this.controllBar.current &&
                            this.controllBar.current.timeBar &&
                            this.controllBar.current.timeBar.current &&
                            this.controllBar.current.timeBar.current.offsetWidth) ||
                            0, (this.core && this.core.current && this.core.current.getDuration()) || 0);
                        dispatch({
                            type: 'swipControllBar',
                            currentTime: this.swipCurrentTime,
                        });
                    }, 50);
                }, () => {
                    // touch end
                    // console.log('touch end')
                    if (this.core && this.core.current) {
                        this.core.current.setCurrent(this.swipCurrentTime);
                    }
                    setTimeout(() => {
                        if (this.core && this.core.current) {
                            this.core.current.play();
                        }
                    }, 200);
                    // 添加客户端引流逻辑
                    if (this.core) {
                        const currentTime = this.core && this.core.current && this.core.current.getCurrentTime()
                            ? this.core.current.getCurrentTime()
                            : 0;
                        // 防止跳过试看时间，直接拖动视频进度条，只有截流功能开启才生效
                        if (currentTime >= this.state.mobileClosureTime) {
                            // 视频停止播放
                            this.handlePlayBtnClick('pause');
                            // 出现引流客户端界面组件
                            this.setState({
                                openClient: this.props.videoConfig.guideAppSetting &&
                                    this.props.videoConfig.guideAppSetting.enable
                                    ? this.props.videoConfig.guideAppSetting.enable
                                    : 0,
                            });
                        }
                    }
                }, {
                    scope: this,
                    direct: 'horizontal',
                });
            }
            else {
                // 点击进度条
                tap(this.controllBar.current.timeBar.current, () => {
                    if (this.core && this.core.current && !this.core.current.isPaused()) {
                        this.core.current.pause();
                    }
                    // console.log('点击进度条');
                }, (tapX, tapY) => {
                    // touch end
                    const begin = (this.controllBar &&
                        this.controllBar.current &&
                        this.controllBar.current.timeBar &&
                        this.controllBar.current.timeBar.current &&
                        this.controllBar.current.timeBar.current.getBoundingClientRect().left) ||
                        0;
                    this.tapCurrentTime =
                        calTime(0, begin, tapX, (this.controllBar &&
                            this.controllBar.current &&
                            this.controllBar.current.timeBar &&
                            this.controllBar.current.timeBar.current &&
                            this.controllBar.current.timeBar.current.offsetWidth) ||
                            0, duration) || 0;
                    dispatch({
                        type: 'swipControllBar',
                        currentTime: this.tapCurrentTime,
                    });
                    if (this.core && this.core.current) {
                        this.core.current.setCurrent(this.tapCurrentTime);
                    }
                    let isPlay = true;
                    let timer = setInterval(() => {
                        if (this.core && this.core.current) {
                            let isPaused = this.core.current.isPaused();
                            if (isPaused && isPlay) {
                                this.core.current.play();
                                clearTimeout(timer);
                                isPlay = false;
                            }
                        }
                    }, 500);
                }, {
                    duration,
                });
            }
        }
        if (this.props.playermsg.pauseAfterLeave) {
            this.pauseAfterLeaveObs = new IntersectionObserver(([entry]) => {
                if (entry.intersectionRatio <= 0 && this.core && this.core.current) {
                    // this.core.current.pause();
                    this.core.current.pauseAfterLeave();
                }
            });
            this.pauseAfterLeaveObs.observe((_b = (_a = this.core) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.el.current);
        }
        if (this.props.playermsg.getExposeApisCb) {
            const cb = this.exposeApis();
            this.props.playermsg.getExposeApisCb(cb);
        }
        // if(this.props.playermsg.clickVideoPlayCb) {
        //     value.playermsg,
        //                     value.playBtnStatus,
        //                     value.shortTipsShow,
        //     this.handleClick();
        // }
    }
    componentWillUnmount() {
        var _a;
        this.unBindCoreEvents();
        (_a = this.pauseAfterLeaveObs) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    render() {
        return (React.createElement(VideoContext.Consumer, null, (value) => (React.createElement("div", { style: { height: '100%', overflow: 'auto' }, onClick: this.handleClick.bind(this, value.playermsg, value.playBtnStatus, value.shortTipsShow) },
            this.getRenderArr(value),
            this.state.openClient === 1 ? (React.createElement(TipsMask, { key: "tipsMask", videoWxLanch: value.videoConfig.videoWxLanch, callAppConfig: value.videoConfig.callAppConfig, content: this.state.content })) : null))));
    }
}
export default MobileVideo;
export { MobileVideo };
